import { Component, OnInit, Input } from '@angular/core';
import { getChartTOptions } from './algo-symbol-pl.chart-template';
import { AlgoPLChartInputI } from './algo-symbol-pl-chart.interface';
import { DEFAULT_PRECISION, PERCENT_DIVIDER, Utils } from '@app/_helpers';

@Component({
  selector: 'app-algo-symbol-pl-chart',
  templateUrl: './algo-symbol-pl-chart.component.html',
  styleUrls: ['./algo-symbol-pl-chart.component.scss']
})
export class AlgoSymbolPlChartComponent implements OnInit {
  @Input() data: AlgoPLChartInputI;
  pnl: string;
  maxDD: string;

  chartsOptions;

  constructor(
  ) { }

  ngOnInit(): void {
    this.chartsOptions = getChartTOptions(this.data.chart);
    this.pnl = Utils.precisionUtil(this.data.details.PnL, DEFAULT_PRECISION);
    // Double precision required one for precision (DEFAULT_PRECISION) and one for percent (PERCENT_DIVIDER).
    this.maxDD = Utils.precisionUtil(this.data.details.MaxDD, DEFAULT_PRECISION + PERCENT_DIVIDER) + '%';
  }

}
